export default {
    key: 'activity',
    type: 'Activity',
    isUsingProductConfigPresets: true,
    isUsingProductPresets: false,
    hideCrossSells: false,
    disablePassengers: false,
    activityId: undefined,
    categoryId: undefined,
    defaultDuration: undefined,
    isMultiDay: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    showDuration: true,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: undefined,
    isLocalListing: false,
    steps: [
        {
            routeName: 'offerFlow-activity-steps-step-1-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-activity-steps-step-2-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
        },
    ],
} satisfies ProductConfigActivity;
